import { render } from "./HRMPage.vue?vue&type=template&id=d2bcf84a&ts=true"
import script from "./HRMPage.vue?vue&type=script&lang=ts"
export * from "./HRMPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__